var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yj-form-item",class:[{
    'yj-form-item--feedback': _vm.yjForm && _vm.yjForm.statusIcon,
    'is-error': _vm.validateState === 'error',
    'is-validating': _vm.validateState === 'validating',
    'is-success': _vm.validateState === 'success',
    'is-required': _vm.isRequired || _vm.required,
    'is-no-asterisk': _vm.yjForm && _vm.yjForm.hideRequiredAsterisk
  },
  _vm.sizeClass ? 'yj-form-item--' + _vm.sizeClass : ''
]},[_c('label-wrap',{attrs:{"is-auto-width":_vm.labelStyle && _vm.labelStyle.width === 'auto',"update-all":_vm.form.labelWidth === 'auto'}},[(_vm.label || _vm.$slots.label)?_c('label',{staticClass:"yj-form-item__label",style:(_vm.labelStyle),attrs:{"for":_vm.labelFor}},[_vm._t("label",[_vm._v(_vm._s(_vm.label + _vm.form.labelSuffix))])],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"yj-form-item__content",style:(_vm.contentStyle)},[_vm._t("default"),_vm._v(" "),_c('transition',{attrs:{"name":"yj-zoom-in-top"}},[(_vm.validateState === 'error' && _vm.showMessage && _vm.form.showMessage)?_vm._t("error",[_c('div',{staticClass:"yj-form-item__error",class:{
            'yj-form-item__error--inline': typeof _vm.inlineMessage === 'boolean'
              ? _vm.inlineMessage
              : (_vm.yjForm && _vm.yjForm.inlineMessage || false)
          }},[_vm._v("\n          "+_vm._s(_vm.validateMessage)+"\n        ")])],{"error":_vm.validateMessage}):_vm._e()],2)],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/form/src/form-item.vue